import React, { useState } from 'react';

import { Dialog, DialogContent, DialogTitle, Divider, List, ListItem, ListItemText, makeStyles, IconButton, DialogActions } from '@material-ui/core';
import { FileCopyOutlined, VolumeUp } from '@material-ui/icons';
import { CloseBtn, ShareBtn } from './Button';
import { SuccessToast } from './Toast';
import { toast } from 'react-toastify';


const useStyles = makeStyles((theme) => ({
    Title : {
        fontFamily: 'primary !important',
        fontWeight: '800 !important',
        fontSize: '1.2rem !important',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
        marginTop : '1vh',
    },
    Content : {
        fontFamily: 'primary !important',
        fontWeight: '800 !important',
        fontSize: '1.2rem !important',
        lineHeight: '24px',
        letterSpacing: '-0.011em',
    },
    dialog : {
        backgroundColor : 'black',
        color : 'white',
    },
    label : {
        fontFamily: 'primary !important',
        fontWeight: '800 !important',
        fontSize: '1rem !important',
    },
    listItem : {
        marginBottom : '1vh',
        borderRadius : '5px',
        backgroundColor : '#1c1c1c',
        color : 'white',
        '&:hover' : {
            backgroundColor : '#fe752f',
            color: 'white',
            borderColor: '#fe752f',
        }
    },
    text : {
        overflowX : 'hidden',
        whiteSpace : 'nowrap',
        fontSize : '16px !important',
        fontWeight : '400 !important',
    },
    mobText : {
        overflowX : 'hidden',
        whiteSpace : 'nowrap',
        fontSize : '10px !important',
        fontWeight : '400 !important',
    },
    hover : {
        color : 'white',
        backgroundColor : '#fe752f',
        '&:hover' : {
            backgroundColor : 'black',
            color : '#fe752f',
            borderColor: '#fe752f',
            border : '1px solid',
        }
    },
    notHover : {
        backgroundColor : '#1c1c1c',
        color : '#fe752f',
    },
    volButton : {
        "& .MuiIconButton-label" : {
            width : '2vw',
            height : '2vw',
        },
        "& .MuiSvgIcon-root" : {
            fontSize : '1.5rem !important',
            color : '#fe752f',
        }
    },
    DialogActionStyle : {
        justifyContent : 'center',
    }

}));

const RoomDetailsDialog = function RoomDetailsDialog({ analyzer, view,show, roomName, handleClose, roomChanged }) {

    const classes = useStyles();
    const [hoverRoomName, setHoverRoomName] = useState(false);
    const [hoverRoomLink, setHoverRoomLink] = useState(false);
    // const [copyToast, setCopyToast] = useState(false);
    // const [roomChange, setRoomChange] = useState(roomChanged || false);
    const [display, setDisplay] = useState(false);
    if(roomChanged || false){
        toast.success("Room Name Changed!");
    }
    var handleCopyLink = (e) => {

        let copyText1 = document.getElementById(e);
        copyText1.disabled = false;
        copyText1.select();
        document.execCommand("copy");
        copyText1.disabled = true;
        // setCopyToast(true);
        toast.success("Copied to clipboard!",{
            toastId:"Copied to clipboard!"
        })

    }

    var handleShare = ()=> {
        //window.origin.slice(8,) + "/portal/" + 
        if (!navigator.share) return;
        navigator.share({
        title: 'Teleport : File Sharing Tool',
        text: 'Join my room '+ roomName  + ' on Teleport to receive files',
        url: roomName,
        });
    }

    var handleAudio = () => {
            let payload = roomName.toUpperCase().replace(/\s/g, '');
            let tpay = "";
            payload.split("").forEach(ele => {
                if(tpay.slice(-1) === ele){
                    tpay += "_"
                }
                tpay += ele;
            })
            setDisplay(true);
            tpay = tpay.replace(/-/g,"");
            analyzer.send(tpay,()=>{
                setDisplay(false);
            })
    }

    return (
        <Dialog classes={{ paper : classes.dialog }} maxWidth='xl' open={show || false}>
            <DialogTitle disableTypography={true} classes={{ root : classes.Title }} >
                Room Details
                <CloseBtn view="desktop" handleClick={handleClose} />
            </DialogTitle>
            <Divider />
            <DialogContent classes={{ root : classes.Content }} >
                <List>
                    <ListItem onMouseEnter={()=>{ setHoverRoomLink(true) }} onMouseLeave={()=>{ setHoverRoomLink(false) }} onClick={() => handleCopyLink("link")} classes={{ root : classes.listItem }} button >
                        <ListItemText classes={{ primary : view === 'mobile' ? classes.mobText : classes.text }} primary={window.origin.slice(8,) + "/portal/" + roomName} />
                        <input id="link" disabled={true}  value={ window.origin + "/portal/" + roomName } style={{opacity : 0, width : 1}} />
                        <IconButton  style = { view === 'mobile' ? { float: 'right' ,width : '8vw', height : '8vw', } : { float: 'right' ,width : '3vw', height : '3vw' } } classes={{ root : (hoverRoomLink ? classes.hover : classes.notHover ) }} >
                            <FileCopyOutlined />
                        </IconButton>
                    </ListItem>
                    <ListItem onMouseEnter={()=>{ setHoverRoomName(true) }} onMouseLeave={()=>{ setHoverRoomName(false) }} onClick={() => handleCopyLink("roomNameId")} classes={{ root : classes.listItem }} button >
                        <ListItemText classes={{ primary : view === 'mobile' ? classes.mobText : classes.text }} primary={ roomName } />
                        <input id="roomNameId" disabled={true}  value={roomName} style={{opacity: 0, width : 1 }} />
                        <IconButton  style = { view === 'mobile' ? { float: 'right' ,width : '8vw', height : '8vw' } : { float: 'right' ,width : '3vw', height : '3vw' } } classes={{ root : (hoverRoomName ? classes.hover : classes.notHover ) }} >
                            <FileCopyOutlined />
                        </IconButton>
                    </ListItem>
                </List>
            </DialogContent>
            {/* <SuccessToast open={roomChange} message="Room Name Changed!" closeSnack={ ()=> { setRoomChange(false) } } /> */}
            {/* <SuccessToast open={copyToast} message="Copied to clipboard!" closeSnack={ ()=> { setCopyToast(false) } } /> */}
        </Dialog>
    )

}

export default RoomDetailsDialog;